<template>
  <el-calendar v-model="seleteData" id="settingsCalendar">
    <template slot="dateCell" slot-scope="{ seleteData, data }">
      <div class="calendar-work" v-if="datas[data.day] == 'Y'" :title='data.day.split("-").slice(1).join("-")'>
        <span v-if="issample != 'Y'">{{ data.day.split("-").slice(1).join("-") }}</span> 班
      </div>
      <div class="calendar-unwork" v-if="datas[data.day] == 'N'"  :title='data.day.split("-").slice(1).join("-")'>
        <span v-if="issample != 'Y'">{{ data.day.split("-").slice(1).join("-") }}</span> 休
      </div>
      <div v-if="!datas[data.day]"  :title='data.day.split("-").slice(1).join("-")'>
        <span v-if="issample != 'Y'">{{ data.day.split("-").slice(1).join("-") }}</span>
      </div>
    </template>
  </el-calendar>
</template>

<script>
export default {
  props: {
    issample: String,
  },
  data() {
    return {
      seleteData: "",
      datas: {},
    };
  },
  methods: {
    getMHD() {
      let _this = this;

      _this.$http.post(
        ["system/calendar/getYMD"],
        [
          function (data) {
            _this.seleteData = new Date(data);
          },
        ], "#settingsCalendar>.el-calendar__header"
      );
    },
    getDatas(val) {
      let _this = this;

      _this.$http.post(
        ["system/calendar/get", { dateStr: val }],
        [
          function (data) {
            _this.datas = [];

            for (var i in data) {
              _this.datas[data[i].dateStr] = data[i].isWork;
            }
          },
        ], "#settingsCalendar>.el-calendar__body"
      );
    },
    markDay(val) {
      let _this = this;
      let isWork = _this.datas[val];

      if (_this.issample == 'Y') {
        return;
      }

      isWork = isWork == "Y" ? "N" : "Y";
      _this.datas[val] = isWork;
      _this.$http.post(
        ["system/calendar/save", { dateStr: val, isWork: isWork }],
        [
          function (data) {
            _this.datas[val] = isWork;
          },
        ], "#settingsCalendar>.el-calendar__body"
      );
    },
  },
  mounted() {
    this.getMHD();
  },
  watch: {
    seleteData(val, preval) {
      var valstr = this.$tools.dateToDay(val);
      var prestr = preval ? this.$tools.dateToDay(preval) : null;

      if (valstr == prestr) {
        this.markDay(valstr);
      } else {
        valstr = this.$tools.dateToMonth(val);
        prestr = preval ? this.$tools.dateToMonth(preval) : null;

        if (valstr != prestr) {
          this.getDatas(valstr);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.calendar-info {
  margin: 10px;
}

.el-calendar-table {
  .el-calendar-day {
    padding: 0px !important;
  }
}

.calendar-work {
  height: 100%;
  width: 100%;
  background-color: #f0f9eb;
  color: #67c23a;
}
.calendar-unwork {
  height: 100%;
  width: 100%;
  background-color: #fef0f0;
  color: #f56c6c;
}
</style>
